export default __webpack_public_path__ + "static/047-785142844954505fbcda9eb91d33ba2f.png";